import { defineStore } from "pinia";
// @ts-ignore
import VueJWTDecode from 'vue-jwt-decode';
import Keycloak from "keycloak-js";
import axios from "axios";

export const useAuthStore = defineStore("authStore", {
    state: () => {
        return {
            //user info
            given_name: "",
            family_name: "",
            email: "",
            email_verified: "",
            preferred_username: "",
            sessiontoken: "",

            user_role: "",
            userRoles: ["client", "printer"],
            users: [] as any,
            printerUsers: [] as string[],
            adminUsers: [] as string[],

            keycloak: new Keycloak(
                {
                    url: 'https://keycloak.wmaut.de',
                    realm: 'application',
                    clientId: 'printer-system',
                }
            ),
        };
    },
    actions: {
        /**
         * Decodes the jsonWebToken string and loads in the account information from keyCloak.
         * @param token tokenstring
         */
        decodeJWT(token: string) {
            this.sessiontoken = token;
            const decoded_token = VueJWTDecode.decode(token);

            this.given_name = decoded_token.given_name;
            this.family_name = decoded_token.family_name;
            this.email = decoded_token.email;
            this.email_verified = decoded_token.email_verified;
            this.preferred_username = decoded_token.preferred_username;
        },
        /**
         * Gets the user role the specified user has from the server.
         * @param user_short
         */
        // @ts-ignore
        async fetchUserRole(user_short: string = this.preferred_username) {
            try {
                const responseObject: any = await axios.get(`${process.env.VUE_APP_API_URL}/database/users/user_role/${user_short}`,
                    {
                        headers: {
                            Authorization: `Bearer ${this.sessiontoken}`
                        }
                    }
                );
                this.user_role = responseObject.data;
            }
            catch (e) {
                this.user_role = this.userRoles[0];
            }
        },
        /**
         * Sets the printerUser variable with the user, which have the role printer.
         */
        async fetchAllPrinterUsers() {
            try {
                const responseObject: any = await axios.get(`${process.env.VUE_APP_API_URL}/database/users/printers`,
                    {
                        headers: {
                            Authorization: `Bearer ${this.sessiontoken}`
                        }
                    }
                );
                const users = responseObject.data

                this.printerUsers = users
                    .filter((u: any) => u.roles.includes("printer"))
                    .map((u: any) => u.name)

                this.adminUsers = users
                    .filter((u: any) => u.roles.includes("admin"))
                    .map((u: any) => u.name)
            }
            catch (e) {
                console.log(e);
            }
        },
        logout() {
            this.keycloak.logout();
        }
    },

});